import { Trans } from 'react-i18next'

import {
  BankTransferIcon,
  GiftCardIcon,
  OriginalPaymentMethodIcon,
  refundMethods,
  StoreCreditIcon,
} from '@reveni-io/reveni-ui'

export const getExtraCreditBonus = (refundMethodExtraAmount, refundMethodSelected) => {
  const bonuses = {
    store_credit_extra_amount: 0,
    gift_card_extra_amount: 0,
  }
  const bonusField = `${refundMethodSelected}_extra_amount`

  if (bonusField in bonuses) {
    bonuses[bonusField] = refundMethodExtraAmount
  }

  return bonuses
}

const getStoreCreditHelperText = ({
  isInstant,
  isCancellationsPortal,
  storeName,
  extraStoreCredit,
  textForWhenIssueRefund,
}) => {
  if (isCancellationsPortal) {
    return <Trans i18nKey="storeCreditTextToCancellationsPortal" values={{ storeName }} />
  }

  if (extraStoreCredit && isInstant) {
    return <Trans i18nKey="storeCreditInstantTextWithExtraCredit" values={{ storeName, extraStoreCredit }} />
  }

  if (extraStoreCredit) {
    return (
      <Trans
        i18nKey="storeCreditTextWithExtraCredit"
        values={{ storeName, extraStoreCredit, textForWhenIssueRefund }}
      />
    )
  }

  if (isInstant) return <Trans i18nKey="storeCreditInstantText" values={{ storeName }} />

  return <Trans i18nKey="storeCreditText" values={{ storeName, textForWhenIssueRefund }} />
}

const getOriginalPaymentMethodHelperText = ({ isInstant, isCancellationsPortal, textForWhenIssueRefund }) => {
  if (isCancellationsPortal) return <Trans i18nKey="originalPaymentMethodTextToCancellationsPortal" />
  if (isInstant) return <Trans i18nKey="originalPaymentMethodInstantText" />

  return <Trans i18nKey="originalPaymentMethodText" values={{ textForWhenIssueRefund }} />
}

const getGiftCardHelperText = ({
  isInstant,
  isCancellationsPortal,
  storeName,
  extraGiftCardCredit,
  textForWhenIssueRefund,
}) => {
  if (isCancellationsPortal) {
    return <Trans i18nKey="giftCardTextToCancellationsPortal" values={{ storeName }} />
  }

  if (extraGiftCardCredit && isInstant) {
    return <Trans i18nKey="giftCardInstantTextWithExtraCredit" values={{ storeName, extraGiftCardCredit }} />
  }

  if (extraGiftCardCredit) {
    return (
      <Trans
        i18nKey="giftCardTextWithExtraCredit"
        values={{ storeName, extraGiftCardCredit, textForWhenIssueRefund }}
      />
    )
  }

  if (isInstant) return <Trans i18nKey="giftCardInstantText" values={{ storeName }} />

  return <Trans i18nKey="giftCardText" values={{ storeName, textForWhenIssueRefund }} />
}

const getBankTransferOption = ({ t, refundMethodsCustomNames }) => {
  return {
    icon: <BankTransferIcon size={32} weight="thin" />,
    value: refundMethods.bankTransfer,
    label: refundMethodsCustomNames[refundMethods.bankTransfer] || t('Transferencia instantánea'),
    feeAmountHelperText: t('Recibe tu dinero en tu cuenta bancaria'),
    helperText: (
      <Trans>
        Recibe <strong>YA</strong> tu dinero en tu cuenta bancaria. Gratis y en segundos.
      </Trans>
    ),
    instantHelperText: (
      <Trans>
        Recibe <strong>YA</strong> tu dinero en tu cuenta bancaria. Gratis y en segundos.
      </Trans>
    ),
  }
}

const getStoreCreditOption = ({
  t,
  storeName,
  extraStoreCredit,
  textForWhenIssueRefund,
  refundMethodsCustomNames,
  isCancellationsPortal,
}) => {
  const helperTextParams = { isCancellationsPortal, storeName, extraStoreCredit, textForWhenIssueRefund }

  return {
    icon: <StoreCreditIcon size={32} />,
    value: refundMethods.storeCredit,
    label: refundMethodsCustomNames[refundMethods.storeCredit] || t('Crédito en tienda'),
    helperText: getStoreCreditHelperText({ ...helperTextParams, isInstant: false }),
    instantHelperText: getStoreCreditHelperText({ ...helperTextParams, isInstant: true }),
  }
}

const getOriginalPaymentMethodOption = ({
  t,
  textForWhenIssueRefund,
  refundMethodsCustomNames,
  isCancellationsPortal,
}) => {
  const helperTextParams = { isCancellationsPortal, textForWhenIssueRefund }

  return {
    icon: <OriginalPaymentMethodIcon size={32} weight="thin" />,
    value: refundMethods.originalPaymentMethod,
    label: refundMethodsCustomNames[refundMethods.originalPaymentMethod] || t('Método de pago original'),
    helperText: getOriginalPaymentMethodHelperText({ ...helperTextParams, isInstant: false }),
    instantHelperText: getOriginalPaymentMethodHelperText({ ...helperTextParams, isInstant: true }),
  }
}

const getGiftCardOption = ({
  t,
  storeName,
  extraGiftCardCredit,
  textForWhenIssueRefund,
  refundMethodsCustomNames,
  isCancellationsPortal,
}) => {
  const helperTextParams = { isCancellationsPortal, storeName, extraGiftCardCredit, textForWhenIssueRefund }

  return {
    icon: <GiftCardIcon size={32} />,
    value: refundMethods.giftCard,
    label: refundMethodsCustomNames[refundMethods.giftCard] || t('Tarjeta regalo'),
    helperText: getGiftCardHelperText({ ...helperTextParams, isInstant: false }),
    instantHelperText: getGiftCardHelperText({ ...helperTextParams, isInstant: true }),
  }
}

export const getRefundMethodOptions = optionsParams => {
  return [
    getBankTransferOption(optionsParams),
    getStoreCreditOption(optionsParams),
    getOriginalPaymentMethodOption(optionsParams),
    getGiftCardOption(optionsParams),
  ]
}
